import React from 'react';
import UseContext from "hooks/useContext";
import SectionWrapper, {FormField, textareaClassName} from "../components/SectionWrapper";

const INSTRUCTIONS_MAX_LENGTH = 500;

// "Détails" step: instructions that belong to this mission only. They start from the
// template's own instructions (copied by createOfMission.js) and never write back to it.
const Other = () => {
    const {data, setData, language} = UseContext()
    const label = (key, defaultValue) =>
        language.getValue(`missionCreation.details.${key}`, defaultValue)

    return (
        <SectionWrapper
            title={label('title', 'Consignes')}
            description={label(
                'description',
                'Propres à cette mission, elles ne modifient pas la fiche de poste.'
            )}
        >
            <FormField label={label('tempWorker', 'Pour l\'intérimaire')}>
                <textarea
                    name="other"
                    rows="5"
                    className={textareaClassName}
                    value={data.other ?? ''}
                    maxLength={INSTRUCTIONS_MAX_LENGTH}
                    placeholder={label(
                        'tempWorkerPlaceholder',
                        'Ex : arrivez 15 min en avance et demandez William à l\'accueil'
                    )}
                    onChange={(e) => {
                        const other = e.target.value
                        setData(prevData => ({...prevData, other}))
                    }}
                ></textarea>
            </FormField>
            <FormField label={label('jobbiz', 'Pour l\'équipe Jobbiz')}>
                <textarea
                    name="other_interim"
                    rows="5"
                    className={textareaClassName}
                    value={data.other_interim ?? ''}
                    maxLength={INSTRUCTIONS_MAX_LENGTH}
                    placeholder={label('jobbizPlaceholder', 'Ex : profil autonome souhaité')}
                    onChange={(e) => {
                        const other_interim = e.target.value
                        setData(prevData => ({...prevData, other_interim}))
                    }}
                ></textarea>
            </FormField>
        </SectionWrapper>
    );
};

export default Other;
